import { useCallback, useEffect, useRef, useState } from "react";
import api from "./api";

/**
 * 20 Jun 2026 · App-weite Feature-Flags (admin-schaltbar).
 *
 * Aktuell nur `property_invoices_enabled` — steuert, ob die objektbezogenen
 * Rechnungs-Menüpunkte/Kacheln (Team + Kunde) sichtbar sind und ob
 * `/app/invoices` die Rechnungsansicht statt der sevDesk-Weiterleitung zeigt.
 *
 * Quelle: `GET /api/config/features` (jeder angemeldete Nutzer lesbar).
 * `bumpFeatureFlags()` triggert einen Sofort-Refresh (nach dem Admin-Toggle),
 * damit die Navigation ohne Reload umschaltet.
 */
const FEATURE_FLAGS_EVENT = "weissblom:feature-flags-refresh";

export function bumpFeatureFlags() {
  try {
    window.dispatchEvent(new CustomEvent(FEATURE_FLAGS_EVENT));
  } catch { /* older browsers — ignore */ }
}

export function useFeatureFlags() {
  const [flags, setFlags] = useState({ property_invoices_enabled: false });
  const [ready, setReady] = useState(false);
  const alive = useRef(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/config/features");
      if (!alive.current) return;
      setFlags({ property_invoices_enabled: !!data?.property_invoices_enabled });
    } catch {
      /* silent — behalte vorherige Flags */
    } finally {
      if (alive.current) setReady(true);
    }
  }, []);

  useEffect(() => {
    alive.current = true;
    load();
    const onBump = () => load();
    window.addEventListener(FEATURE_FLAGS_EVENT, onBump);
    return () => {
      alive.current = false;
      window.removeEventListener(FEATURE_FLAGS_EVENT, onBump);
    };
  }, [load]);

  return { propertyInvoices: flags.property_invoices_enabled, ready };
}
